// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"284":"3f5be8b7","366":"ca0f275c","415":"4d5a9dd7"}[chunkId] + ".chunk.js";
};